import { SearchX } from "lucide-react";
import { useTranslation } from "react-i18next";
import { useHistory } from "react-router-dom";

import { WFPButton } from "@/components/ui/button";
import { Card, CardContent, CardDescription, CardHeader } from "@/components/ui/card";

// Catch-all route page; also rendered when a deep-linked deposit cannot be loaded.
export const NotFound = () => {
  const { t } = useTranslation();
  const history = useHistory();

  return (
    <main className="flex min-h-screen items-center justify-center bg-muted p-6 text-foreground">
      <Card className="w-full max-w-md text-center shadow-md">
        <CardHeader className="flex flex-col items-center gap-4">
          <span className="flex size-16 items-center justify-center rounded-full bg-warning-100 text-warning-600">
            <SearchX className="size-8" aria-hidden="true" />
          </span>
          <h1 className="font-semibold text-2xl">{t("notFound.title")}</h1>
          <CardDescription className="text-base">{t("notFound.description")}</CardDescription>
        </CardHeader>
        <CardContent className="flex flex-col justify-center gap-3 sm:flex-row">
          <WFPButton type="button" onClick={() => history.push("/")}>
            {t("notFound.goToHomePage")}
          </WFPButton>
          <WFPButton type="button" variant="outline" onClick={() => history.goBack()}>
            {t("notFound.goBack")}
          </WFPButton>
        </CardContent>
      </Card>
    </main>
  );
};
